import React from 'react';
import * as Render from '../Base/Render';
import View from './view';
import ToggleChapter from '../ToggleChapter';

const ChapterContainer = (props) => {
  return props.AnchorSectionId && props.Heading && !props.showBlocksInMobileAlways ? (
    <ToggleChapter
      Heading={Render.Property(props.Heading, 'Heading')}
      id={props.UniqueBlockId}
      AnchorSectionId={props.AnchorSectionId}
      isChapterContainer
    >
      <View
        {...props}
        Heading={Render.Property(props.Heading, 'Heading')}
        isNav
      />
    </ToggleChapter>
  ) : (
    <View {...props} Heading={Render.Property(props.Heading, 'Heading')} />
  );
};

export default ChapterContainer;
